import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/auth/login";
import CreatorDashboard from "../pages/creator/dashboard";
import SubmitVideo from "../pages/creator/submit-video";
import AdminDashboard from "../pages/admin/dashboard";
import AdminApplications from "../pages/admin/applications";
import AdminVideos from "../pages/admin/videos";
import AdminCreators from "../pages/admin/creators";
import EditProfile from "../pages/creator/edit-profile";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/creator/dashboard",
    element: <CreatorDashboard />,
  },
  {
    path: "/creator/submit-video",
    element: <SubmitVideo />,
  },
  {
    path: "/creator/edit-profile",
    element: <EditProfile />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/admin/applications",
    element: <AdminApplications />,
  },
  {
    path: "/admin/videos",
    element: <AdminVideos />,
  },
  {
    path: "/admin/creators",
    element: <AdminCreators />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
